var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitalAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25987_4015",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.251953,
    y: 0.707764,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25987_4015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25195 12.0411H9.25195V9.70776H11.5853V7.70776H9.25195V5.37443H7.25195V7.70776H4.91862V9.70776H7.25195V12.0411ZM3.58529 14.7078C3.21862 14.7078 2.90473 14.5772 2.64362 14.3161C2.38251 14.055 2.25195 13.7411 2.25195 13.3744V4.0411C2.25195 3.67443 2.38251 3.36054 2.64362 3.09943C2.90473 2.83832 3.21862 2.70776 3.58529 2.70776H12.9186C13.2853 2.70776 13.5992 2.83832 13.8603 3.09943C14.1214 3.36054 14.252 3.67443 14.252 4.0411V13.3744C14.252 13.7411 14.1214 14.055 13.8603 14.3161C13.5992 14.5772 13.2853 14.7078 12.9186 14.7078H3.58529ZM3.58529 13.3744H12.9186V4.0411H3.58529V13.3744Z",
    fill: "#63666A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalAccess);
export default __webpack_public_path__ + "static/media/Hospital Access.d01ff2132e186f508b445fe6140f21f6.svg";
export { ForwardRef as ReactComponent };